<template>
	<div class="h-100">
		<layout-default class="h-100" v-if="$route.meta.logLayout===false"></layout-default>
		<layout-log v-if="$route.meta.logLayout"></layout-log>
	</div>
</template>

<script>
	
    import {TaskWorker} from '@/services/task';

	import LayoutLog from '@/views/layout/Log';
	import LayoutDefault from '@/views/layout/Default';
	
	export default {
		components: {
			LayoutLog,
			LayoutDefault,
		},
		created: function () {
			this.initTaskWorker();
			this.initForegroundSync();
		},
		
		beforeDestroy: function () {
			document.removeEventListener('visibilitychange', this.onVisible);
		},
		
		methods: {
			initTaskWorker: function () {
				this.taskWorker = new TaskWorker(process.env.VUE_APP_TASK_WORKER_INTERVAL);
				this.taskWorker.init();
			},
			
			// le setInterval du TaskWorker vit dans la page : l'OS le gele des que
			// l'app passe en arriere plan. Au retour au premier plan on relance la
			// sync sans attendre le tick cron.
			initForegroundSync: function () {
				this.startupSync();
				document.addEventListener('visibilitychange', this.onVisible);
			},
			
			// le requeue ne vaut qu'ici : au demarrage aucune sync ne peut etre en
			// cours, donc un SYNC_RUNNING persiste est forcement un reliquat d'une
			// session interrompue. Le faire a chaque retour au premier plan
			// requalifierait une requete encore en vol et la reposterait.
			startupSync: async function () {
				// vuex-persist restaure de maniere asynchrone : requalifier avant
				// travaillerait sur un store vide, et la restauration remettrait
				// ensuite les SYNC_RUNNING persistes, bloques jusqu'au prochain
				// demarrage
				await this.$store.restored;
				await this.$store.dispatch('interventions/requeueRunning');
				await this.$store.dispatch('pictures/requeueRunning');
				await this.sync();
			},
			
			onVisible: function () {
				if (document.visibilityState === 'visible') {
					this.sync();
				}
			},
			
			// hors ligne la sync rejette a chaque tentative : sans ce catch chaque
			// echec remonte en unhandledrejection, l'etat de synchronisation etant
			// deja gere dans les stores
			sync: function () {
				return this.taskWorker.runSync().catch((e) => {
					console.log('sync error', e);
				});
			}
		}
	}

</script>
